'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function waitFactory(ms) {
  function wait(_ref) {
    var path = _ref.path;

    return new Promise(function (resolve) {
      setTimeout(function () {
        return resolve(path ? path.continue() : null);
      }, ms);
    });
  }
  wait.displayName = 'wait - ' + ms + 'ms';

  return wait;
}

exports.default = waitFactory;
//# sourceMappingURL=wait.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/operators/wait.js
// module id = 266
// module chunks = 0